export class CookiesService {
	constructor() {
		'ngInject';
	}

	/**
	 * Take a cookie string and parse into an object
	 * @param cookies String  e.g., "_octo=GH1.1.1671679664.1597674104; tz=America%2FDenver"
	 * @credit https://gist.github.com/rendro/525bbbf85e84fa9042c2#gistcomment-2784930
	 *
	 * @return {Object}  e.g., { _octo: 'GH1.1.1671679664.1597674104', tz: 'America/Denver' }
	 */
	parseToObject(cookies) {
		return cookies.split(';').reduce((res, cookie) => {
			const [key, val] = cookie.trim().split('=').map(decodeURIComponent);
			try {
				return Object.assign(res, { [key]: JSON.parse(val) });
			} catch (e) {
				return Object.assign(res, { [key]: val });
			}
		}, {});
	}

	/**
	 * Checks whether the user has the cookie and value `ShCookieConsent=true`
	 * @returns {Boolean}
	 */
	optionalConsentGranted() {
		const match = document.cookie.match(/ShCookieConsent=([^;]+)/);
		return match && match[1] && match[1] === 'true';
	}

	/**
	 * Changes the value of the `ShCookieConsent` cookie
	 * @param enabled Boolean
	 */
	updateOptionalConsent(enabled) {
		// expires in 10 years
		const maxAge = '; max-age=' + 3600 * 24 * 365 * 10;
		document.cookie = 'ShCookieConsent=' + enabled + maxAge;
		if (enabled === false) {
			this.expireOptionalCookies();
		}
	}

	/**
	 * Will return `true` if the user has the `ShCookieConsent` cookie of any value. This means they have either
	 * accepted or declined the optional cookies.
	 * @returns {Boolean}
	 */
	hasConsentCookie() {
		return document.cookie.match(/ShCookieConsent=/) !== null;
	}

	/**
	 * Expire optional cookies if the user withdraws consent
	 */
	expireOptionalCookies() {
		const cookies = this.parseToObject(document.cookie);
		Object.keys(cookies).forEach(cookieKey => {
			// this could be changed to a regex match if we had other optional cookies to remove in the future
			if (cookieKey.match('SnapABug')) {
				document.cookie = cookieKey + '=; max-age=-1; path=/;';
			}
		});
	}
}
